export default "__VITE_PUBLIC_ASSET__be872cfc__"